import React from 'react';
import UseCaseCard from '@/Components/UseCaseCard';
import { motion } from 'framer-motion';
import drip_design from '../../../assets/drip-design.png';
import Image from 'next/image';

import { DripIrrigationCaseData } from '../../../Data/UseCaseData';
import MetaHead from '@/Components/MetaHead';
import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import { Button } from '@/Components/Button';
import Link from 'next/link';

export default function DripIrrigation() {
  return (
    <div>
      <MetaHead title="For Irrigation Solution Company | Fyllo" />
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-left lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-xl">
          <MainHeading text="For Irrigation System companies" />
          <SubHeading text="If you are a company with irrigation systems across automation , micro irrigation or fertigation systems , Fyllo can help your customer grow better quality produce and save more on irrigation. Fyllo users have saved over 33% water over normal drip users" />
        </div>
      </div>

      <div className="pb-10 grid md:grid-cols-2 gap-2 md:gap-10 mx-auto max-w-screen-xl p-5">
        <div className="grid gap-10 ">
          {DripIrrigationCaseData.map((content, i) => {
            return (
              <div key={i} className=" flex flex-col p-5">
                <p className="text-3xl text-gray-400 md:text-5xl font-black">0{i + 1}.</p>
                <div className=" text-xl md:text-2xl  pt-3 text-gray-600"> {content.title}</div>
              </div>
            );
          })}
        </div>
        <div className="grid place-items-center">
          <Image
            className="m-5 md:w-1/2 border rounded-xl shadow-xl hover:shadow-4xl hover:scale-110 transition-all"
            src={drip_design}
            alt="drip design"
            sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
          />
        </div>
      </div>
      <div className="my-10 mx-10 md:my-24 flex justify-center">
        <Link href={'/contact#contact_form'}>
          <Button size="lg">Explore Partnership With Fyllo</Button>
        </Link>
      </div>
    </div>
  );
}
